import { find, get } from 'lodash';

export function isDefaultProgramSelected(groupsPrograms, values, defaultProgram) {
  const programId = values?.program?.id;

  if (!programId) {
    return get(defaultProgram, 'attributes.default', false);
  }

  const selectedProgram = find(
    get(groupsPrograms, 'data', []),
    (program) => program.id === programId,
  );

  return get(selectedProgram, 'attributes.default', false);
}
